import { type BundleKey, type Issue } from './types';

/** Field errors for one entry (or one section object), keyed by path. */
export type FieldErrors = Record<string, Issue[]>;

export function issuesFor(issues: Issue[], section: BundleKey, index?: number): FieldErrors {
  const out: FieldErrors = {};
  for (const i of issues) {
    if (i.section !== section || i.index !== index) continue;
    (out[i.path] ??= []).push(i);
  }
  return out;
}

/** Every issue at `base` or under it (`base.0.id`, ...), for a list edited in one control. */
export const issuesUnder = (errors: FieldErrors, base: string): Issue[] =>
  Object.entries(errors)
    .filter(([path]) => path === base || path.startsWith(`${base}.`))
    .flatMap(([, list]) => list);

export const errorCount = (issues: Issue[]) => issues.filter((i) => i.severity === 'error').length;
